import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import React from "react";
import { useStylesNavBar } from "./style";
import { useTranslation } from "react-i18next";
import { COIN_NET, TEST_NET } from "../../utils/WalletUtils";

const NetworkOption = ({ endpoint, handleChangeEndPoint }) => {
  const classes = useStylesNavBar();
  const { t } = useTranslation();
  return (
    <div className="HomeSelect TestSign">
      {/* Dropdown to select TestNet ot CoinNet */}
      <FormControl className={classes.formControl}>
        <Select
          value={endpoint}
          onChange={(e) => handleChangeEndPoint(e)}
          displayEmpty
          className={classes.selectEmpty}
          inputProps={{ "aria-label": "Without label" }}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            getContentAnchorEl: null,
          }}
        >
          {/*FIXME : Only TestNet*/}
          <MenuItem disabled value={COIN_NET}>
            {t("CoinNet")}
          </MenuItem>
          <MenuItem value={TEST_NET}>{t("TestNet")}</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};
function areEqual(prevProps, nextProps) {
  return prevProps.endpoint === nextProps.endpoint;
}
export default React.memo(NetworkOption, areEqual);
